export const capitalizedFirst = (text: string) => {
  return text.trim().charAt(0).toUpperCase() + text.trim().slice(1)
}
